export enum SmAssetType {
    PRE_EMPTIVE = 'pre_emptive',
    SHARE = 'share',
}

export enum SmOrderBookDirectionType {
    IN = 'in',
    OUT = 'out',
}

export enum SmOrderBookSourceType {
    ADMIN_ADJUSTMENT = 'admin_adjustment',
    IMPORT = 'import',
    INVESTMENT = 'investment',
    SECONDARY_MARKET = 'secondary_market',
    EXERCISE = 'exercise',
}

export enum SmListingStatusType {
    OPEN = 'open',
    RESERVED = 'reserved',
    SOLD = 'sold',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
}

export enum SmBuyRequestStatusType {
    OPEN = 'open',
    FULFILLED = 'fulfilled',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
}

export enum OfferStatusType {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    EXPIRED = 'expired',
}

export enum TransactionStatus {
    INITIATED = 'initiated',
    BUYER_SIGNED = 'buyer_signed',
    SELLER_SIGNED = 'seller_signed',
    PENDING_PAYMENT = 'pending_payment',
    COMPLETED = 'completed',
    FAILED = 'failed',
    WAITING_FOR_APPROVAL = 'waiting_for_approval',
}
